import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

const HomePage = () => {
  return (
    <div className="mx-auto md:w-10/12 lg:w-8/12 xl:w-6/12">
      <Card className="shadow-lg">
        <CardHeader className="">
          <h1 className="text-center text-2xl">
            Notariza tus documentos online
          </h1>
        </CardHeader>

        <CardContent className="flex flex-col gap-6">
          <p>
            Descubre la solución perfecta para pequeñas y medianas empresas. Con
            nuestra plataforma, puedes firmar documentos online utilizando Firma
            Electrónica Simple y Firma Electrónica Avanzada. Estamos conectados
            a una red de notarios en Chile, lo que nos permite certificar y
            autorizar documentos de manera rápida y segura.
          </p>

          <p>
            Ahorra tiempo y simplifica tus procesos con nuestra tecnología .
            ¡Transforma la manera en que gestionas tus documentos hoy mismo!
          </p>

          <div className="flex justify-center">
            <Button asChild>
              <a href="https://firme.cl/">Más información</a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export { HomePage }
